module.exports = __webpack_public_path__ + "static/media/merchant_food_voucher.16e3cd73.png";